import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { InfoIcon } from '@navi/web-ui/lib/icons';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { getRightHeaderLabel } from '../utils';
import { InformationType, RightHeaderType } from '../../../types';

interface IRightHeaderProps {
  type?: string;
  onClick?: () => void;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  component?: string;
}

const RightHeader = (props: IRightHeaderProps) => {
  const {
    onClick,
    endAdornment,
    type = InformationType.BUTTON,
    startAdornment,
    component = RightHeaderType.OUTPUT
  } = props;

  const mockStatus = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails?.status
  );

  const mockOutputStatus = useSelector(
    (state: RootState) =>
      state?.fieldAllocation?.fieldAllocationDetails?.mockAllocationData?.preparationStatus
  );

  const label = getRightHeaderLabel(mockStatus?.value, component, mockOutputStatus?.value);

  if (type === InformationType.TEXT && label?.length)
    return (
      <div className="flex items-center gap-1">
        <InfoIcon color="var(--grayscale-2)" />
        <Typography variant="h5" color="var(--grayscale-2)">
          {label}
        </Typography>
      </div>
    );

  return (
    <Button
      onClick={onClick}
      variant="text"
      className="text-center"
      endAdornment={endAdornment}
      startAdornment={startAdornment}
    >
      <Typography variant="h4" color="var(--navi-color-blue-base)">
        {label}
      </Typography>
    </Button>
  );
};

export default RightHeader;
